import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ColDef, ExcelExportParams,GridApi,GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-ess-details-popup',
  templateUrl: './ess-details-popup.component.html',
  styleUrls: ['./ess-details-popup.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class EssDetailsPopupComponent implements OnInit {
  buttonColorName: any
  PopupName: any
  invitationEmailBody: any = '';
  submissionEmailBody: any = '';
  isEditorInitialized: boolean = false;
  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: '400px',
  //   minHeight: '0',
  //   maxHeight: 'auto',
  //   width: 'auto',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter Email here...',
  //   defaultParagraphSeparator: '',
  // }
   editorConfig: any = {
    height: 500,
    toolbarSticky: false,
    toolbarAdaptive: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_clear_html',
    uploader: {
      insertImageAsBase64URI: true // 💡 This enables local image embedding
    },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'link', 'image', '|',
      'undo', 'redo', '|',
      'fontsize'
    ]
  };
  createSurveyForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserRole: any;
  selectedYear: any;
  minDate = new Date();
  intructionList: any = [];
  selectedLocationForSetup: any = [];
  selectedBandForSetup: any = [];
  selectedGradeForSetup: any = [];
  selectedFunctionForSetup: any = [];
  surveyDateOfJoining: any;
  isPublished: boolean = false;
  selectedSurveyID: any;
  selectedEssendDate: any;
  moduleName: any;
  myMasterSelectedYear:any;
  isFieldsDisabled:boolean=false;
  getPopupName:any;
  recentlyCreatedSurveyName: any;
  arrViewEmployeecolumnDefs:any =[];
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public sharedService: SharedService, public dialogRef: MatDialogRef<EssDetailsPopupComponent>,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe, public dialog: MatDialog,
    private route: ActivatedRoute, public toastr: ToastrService,private pdfDownload:DownloadAsPdfService, public mobileResponsiveService: MobileResponsiveService ) { }

  ngOnInit() {
      
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.PopupName = this.data.popupName;
    this.moduleName = this.data.moduleName;
    this.selectedYear = this.data?.year;
    this.myMasterSelectedYear = this.sharedService.transformYearToFyFormat(this.data?.year);
    this.selectedLocationForSetup = this.data?.selectedLocationForSetup
    this.selectedBandForSetup = this.data?.selectedBandForSetup
    this.selectedGradeForSetup = this.data?.selectedGradeForSetup
    this.selectedFunctionForSetup = this.data?.selectedFunctionForSetup
    this.surveyDateOfJoining = this.data?.surveyDateOfJoining
    this.isPublished = this.data?.isPublished;
    this.selectedEmployeeId = this.data?.selectedEmployeeId ? this.data?.selectedEmployeeId : [];
    this.selectedEssendDate = this.data?.endDate
    this.selectedSurveyID = this.data?.selectedSurveyID;
    console.log( "suervey ID............",this.data?.selectedSurveyID );
    this.getHeaderColumnDefsForViewEmployee();
this. initilaizeAddSurveyForm();
  setTimeout(()=>{
 this.mailTeplateFunction();
  },300)
  
  }
isEditorReady(): boolean {

  
  return this.editorConfig &&  this.invitationEmailBody !== undefined;
}
  mailTeplateFunction(){
       if (this.moduleName == 'ESS') {
      if (this.data?.invitationEmailBody) {
        this.invitationEmailBody = this.data?.invitationEmailBody;
      } else {
        this.invitationEmailBody = `Dear <b>#EMPLOYEE_NAME#</b>, <br/>
        You are invited to participate in our <b>ESS Survey</b> titled <b>“#ESS_SURVEY_NAME#”</b>.
        Your feedback is important to us and will help improve our workplace environment and processes.
        <ul>
          <li style="margin-left:15px;"><b>Survey Start Date: </b>#START_DATE#</li>
          <li style="margin-left:15px;"><b>Survey End Date: </b>#END_DATE#</li>
        </ul>
        Please click the link below to participate:<br/>
        <b>#LOGIN_URL#</b>
        The survey will take only a few minutes to complete. Your responses will be kept confidential, and we truly value your input.
       
        Thank you for your time and support!<br/><br/>
        
        <p>Best regards,</p>
        <p><b>#COMPANY_NAME#</b><br/>
        <b>HR/Survey Team</b></p>`;
        
      }
      this.invitationEmailSubject = this.data?.invitationEmailSubject ? this.data?.invitationEmailSubject : 'Your Feedback Matters: Participate in the ESS Survey Now!';
      this.submissionEmailBody = this.data?.submissionEmailBody
      if (this.data?.submissionEmailBody) {
        this.submissionEmailBody = this.data?.submissionEmailBody;
      } else {
        this.submissionEmailBody = `
        Dear <b>#EMPLOYEE_NAME#</b>,
        <br /> <br />
        Thank you for completing the Employee Satisfaction Survey (ESS).
        <br /><br />
        <b>Survey Details:</b> 
        <br /><br />
        <ul>
          <li style="margin-left:15px;"><b>Survey Name:</b> #ESS_SURVEY_NAME#</li>
          <li style="margin-left:15px;"><b>Submitted On:</b> #SUBMISSION_DATE#</li>
        </ul>
        <br /><br />
        Your feedback is valuable and will help us improve our workplace. If you have further suggestions, feel free to contact HR
        <br /><br />
        Best regards, 
        <br />
        <b>#HR_ADMIN_NAME# </b>,
        <br />Human Resources Team`;
      }
      this.submissionEmailSubject = this.data?.submissionEmailSubject ? this.data?.submissionEmailSubject : 'Thank You for Completing the ESS Survey!';
    } else {
      if (this.data?.invitationEmailBody) {
                
        this.invitationEmailBody = this.data?.invitationEmailBody;
        console.log( this.invitationEmailBody );
        
      } else {
      
        
        this.invitationEmailBody = `Dear <b>#EMPLOYEE_NAME#</b>, 
          <br /> <br />
          The 360-degree feedback review process has been initiated, and you are required to complete one or more  reviews in One or more roles.
          <br /><br />
          <ul>
            <li style="margin-left:15px;"><b>Self-Review:</b> Complete your self-assessment.</li>
            <li style="margin-left:15px;"><b>Superior Review:</b> Provide feedback for your direct report(s). ( Superior Review Emps )</li>
            <li style="margin-left:15px;"><b>Peer Review:</b> Share your feedback for your colleagues.( Peer Review Emps )</li>
            <li style="margin-left:15px;"><b>Subordinate Review:</b> Provide feedback for your manager. ( Subordinate Review Emps )</li>
            <li style="margin-left:15px;"><b>Internal Customer Review:</b> Give feedback on service/support received. ( Internal Customer Review Emps )</li>
          </ul>
          <br /><br />
          To ensure timely completion, please submit your reviews before [Due Date].
          <br /><br />
          Access the survey: [Link to Review Portal]
          <br/><br/>
          Best regards, 
          <br />
          <b>#HR_ADMIN_NAME# </b>,
          <br />Human Resources Team`;
      }
      this.invitationEmailSubject = this.data?.invitationEmailSubject ? this.data?.invitationEmailSubject : 'Requests for 360-Degree Feedback ( Survey Name)';
      this.submissionEmailBody = this.data?.submissionEmailBody
      if (this.data?.submissionEmailBody) {
        this.submissionEmailBody = this.data?.submissionEmailBody;
      } else {
        this.submissionEmailBody = `
          Dear <b>#EMPLOYEE_NAME#</b>,
          <br /> <br />
          Thank you for taking the time to complete our survey. Your responses have been successfully submitted.
          <br /><br />
          We appreciate your valuable feedback, which will help us improve our [purpose of the survey]. If you have any further input, feel free to reach out to us.          <br /><br />
          Best regards, 
          <br />
          <b>#HR_ADMIN_NAME# </b>,
          <br />Human Resources Team`;
      }
      this.submissionEmailSubject = this.data?.submissionEmailSubject ? this.data?.submissionEmailSubject : 'Thank You for Completing the Survey!';
    }
    
    if (this.data?.intructionList.length !== 0) {
      this.intructionList = this.data?.intructionList;
      let getInstruction: any = [...this.intructionList]; 
      localStorage.setItem('intructionList', JSON.stringify(getInstruction));
    }
    
    this.initilaizeAddSurveyForm();
    if (this.PopupName == 'Create Survey') {
      this.getessName();
      
    }
    if (this.PopupName == 'View Employees') {
      this.getEmpListForEssSetup();
    }
    if (this.PopupName == 'My Master') {
      this.getessByID();
    }
    if (this.PopupName == '360 Review') {
      this.getReviewByID();
    }

    // this.route.params.subscribe((params: any) => {
    //   console.warn('params', params);
      
    // });
    const urlPath = this.router.url;  
    const getUrlPath = urlPath.split('/').pop()?.split(';')[0];

    if(getUrlPath == 'threeSixtyDegree'){
      this.getPopupName = '360 Degree Invitation Email'
    }else {
      this.getPopupName = 'ESS Invitation Email'
    }
  }


  
  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = false;
  paginationPageSize = 10000000;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };
  
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,
  
      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string,commentType:any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: { 
        text: text,
        commentType: commentType
      }
    });
  
  }

  // onGridReady(params: GridReadyEvent) {
  //   this.gridApi = params.api;
  //   params.api.sizeColumnsToFit();
  //   console.log(params)
  // }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';
  
    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';
  
    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  }
  
  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;
  
    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
   
  }
  
  onBtExport(strMsg:any) {
    const params: ExcelExportParams = {
      fileName: strMsg+'_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: strMsg,
      exportAsExcelTable: {
        showRowStripes: true,
        name: strMsg
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;
  
        // 1. Date Formatting (for specific headers)
        const dateColumns = ['startDate', 'endDate']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }
  
        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char:any) => char.toUpperCase()); // capitalize each word
        }
  
        return value;
      }
    };
  
    this.gridApi.exportDataAsExcel(params);
  }
  
   
  
  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

    // Helper function to convert any date string into dd-MM-yyyy
    formatDateOnly(dateStr: string | null): string | null {
      if (!dateStr) return null;
    
      let datePart = dateStr;
      if (dateStr.includes('T')) {
        datePart = dateStr.split('T')[0];  
      }
    
      const [y, m, d] = datePart.split('-').map(Number);
      if (!y || !m || !d) return null;
    
      // Date object 
      const date = new Date(y, m - 1, d);
    
      // Format dd-MM-yyyy
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

 isClicked = false;
 

  resetGrid() {
    this.isClicked = true; // Trigger animation
  
    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();
  
      // ✅ Reset quick filter (search box)
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
  
      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();
  
      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
// --------------------------------AG GRID CODE---------------------------------------------------------
  getHeaderColumnDefsForViewEmployee(){
    this.arrViewEmployeecolumnDefs = [
      {
        headerName: 'Emp. Id.',
        field: 'employeeId',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 120
      },
      { headerName: 'First Name', field: 'firstName' },
      { headerName: 'Last Name', field: 'lastName' },
      { headerName: 'DOJ', field: 'dateOfJoining', valueFormatter: (params: any) => {
          return params.value ? new Date(params.value).toLocaleDateString('en-GB') : '';
        }
      },
      { headerName: 'Designation', field: 'designation' },
      { headerName: 'Department', field: 'department' },
      { headerName: 'Manager', field: 'reportingManagerName' },
      { headerName: 'Location', field: 'officeLocation' },
      { headerName: 'Band', field: 'band' },
      { headerName: 'Grade', field: 'grade' },
    ];
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    // this.gridColumnApi = params.columnApi;
  
    // ✅ Pre-select rows based on isChecked
    this.gridApi.forEachNode((node: any) => {
      if (node.data.isChecked) {
        node.setSelected(true);
      }
    });
  
    // ✅ Set initial state of "select all"
    this.isAllEmployeeSelected = this.listOfEmployees.every((e:any) => e.isChecked);
  }
  

  
  onSelectionChanged(event: any) {
    const selectedNodes = event.api.getSelectedNodes();
    this.selectedEmployeeId = selectedNodes.map((node: any) => node.data);
  
    // keep sync with isChecked property
    this.listOfEmployees.forEach((emp:any) => {
      emp.isChecked = this.selectedEmployeeId.some((sel:any) => sel.employeeId === emp.employeeId);
    });
  
    // header selectAll status
    this.isAllEmployeeSelected = this.listOfEmployees.every((emp:any) => emp.isChecked);
  }
  
  



  initilaizeAddSurveyForm() {
    this.createSurveyForm = this.fb.group({
      essName: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
  createSurvey() {

    const test = this.selectedYear?.split('-');
    this.createSurveyForm.markAllAsTouched();
    if (this.createSurveyForm.valid) {
      // this.closeDialog();
      const request = {
        "band": [],
        "companyId": this.loggedInUserCompanyID,
        "department": [],
        "dimension": [],
        "employee": [],
        "endDate": this.datePipe.transform(this.createSurveyForm.value.endDate, "yyyy-MM-dd"),
        "essName": this.createSurveyForm.value.essName,
        "essStatus": "Pending",
        "fromYear": test[0],
        "grade": [],
        "id": null,
        "instruction": [],
        "invitationEmailBody": null,
        "invitationEmailSubject": null,
        "isReminderOn": false,
        "isReportsVisibleToHr": false,
        "location": [],
        "ratings": [],
        "reminderDate": [],
        "startDate": this.datePipe.transform(this.createSurveyForm.value.startDate, "yyyy-MM-dd"),
        "submissionEmailBody": null,
        "submissionEmailSubject": null,
        "surveyCutoff": null,
        "templateName": null,
        "toYear": test[1]
      }
      this.httpService.callPostService(this.config.essSave, request).subscribe((data: any) => {
          console.log("data...........", data);
          
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe( result => {
                 
             
            
              this.dialogRef.close({ id: data?.data?.id });
         
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          }
        })
    }
  }

 
  
  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }



  instructionName: any = '';
  isInstructionPresent:any;
  onClickAddInstruction() {
    let getInstruction = localStorage.getItem('intructionList');
    let instructionArray: string[] = getInstruction ? JSON.parse(getInstruction) : [];
    if (this.instructionName.trim() !== '') {
      if (instructionArray.includes(this.instructionName)) {
        this.isInstructionPresent = true; 
      } else {
        this.intructionList.push(this.instructionName);
        instructionArray.push(this.instructionName);
        localStorage.setItem('intructionList', JSON.stringify(instructionArray));
        this.instructionName = '';
        this.isInstructionPresent = false; 
      }
    }
  }
  
  onClickRemoveInstruction(index: any) {
    this.intructionList.splice(index, 1);
  }
  onClickCloseInstruction() {
    this.dialogRef.close(this.intructionList);
    localStorage.removeItem('intructionList')
  }
  onClickSaveInstruction() {
    if (this.intructionList.length != 0) {
      this.dialogRef.close(this.intructionList);
      localStorage.removeItem('intructionList')
    } else {
      this.toastr.error('Please fill fields', '', {
        timeOut: 3000,
      });
    }
  }
  invitationEmailSubject: any = 'Your Feedback Matters: Participate in the ESS Survey Now!';
  submissionEmailSubject: any = 'Thank You for Completing the ESS Survey!';
  onClickSaveInvitation() {
    if (this.invitationEmailBody != '' && this.invitationEmailSubject != '') {
      let data = {
        invitationEmailBody: this.invitationEmailBody,
        invitationEmailSubject: this.invitationEmailSubject
      }
      this.dialogRef.close(data);
    } else {
      this.toastr.error('Please fill fields', '', {
        timeOut: 3000,
      });
    }
  }
  onClickCloseInvitation() {
    let data = {
      invitationEmailBody: this.invitationEmailBody,
      invitationEmailSubject: this.invitationEmailSubject
    }
    this.dialogRef.close(data);
  }
  onClickSaveSubmission() {
    if (this.submissionEmailSubject != '' && this.submissionEmailBody != '') {
      let data = {
        submissionEmailSubject: this.submissionEmailSubject,
        submissionEmailBody: this.submissionEmailBody
      }
      this.dialogRef.close(data);
    } else {
      this.toastr.error('Please fill fields', '', {
        timeOut: 3000,
      });
    }
  }
  onClickCloseSubmission() {
    let data = {
      submissionEmailSubject: this.submissionEmailSubject,
      submissionEmailBody: this.submissionEmailBody
    }
    this.dialogRef.close(data);
  }
  listOfEmployees: any = [];
  searchString: any = null;
  getEmpListForEssSetup() {

    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": this.datePipe.transform(this.surveyDateOfJoining, "yyyy-MM-dd"),
      "endDate": this.selectedEssendDate,
      "search": this.searchString
    }
    // this.loader.simpleLoader();
    this.httpService.callPostService(this.config.getEmpListForEssSetup, request).subscribe((data: any) => {
      // this.loader.dismissLoader();
      this.listOfEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          isChecked: false,
          employeeId: ele.employeeId,
          firstName: ele.firstName,
          lastName: ele.lastName,
          dateOfJoining: ele.dateOfJoining,
          designation: ele.designation,
          department: ele.department,
          reportingManagerName: ele.reportingManagerName,
          officeLocation: ele.workLocationCity,
          band: ele.band,
          grade: ele.grade,
        }
        this.listOfEmployees.push(obj);
      });
      this.listOfEmployees.forEach((item: { id: any; isChecked: boolean; }) => {
        if (this.selectedEmployeeId.some((emp: { id: any }) => emp.id === item.id)) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      
      if (this.selectedEmployeeId.length == 0) {
        this.isAllEmployeeSelected = true;
        this.listOfEmployees.forEach((item: { isChecked: boolean; }) => {
          item.isChecked = true;
        });
        this.selectedEmployeeId = this.listOfEmployees;
        console.log( this.selectedEmployeeId )
      }
      if (this.listOfEmployees.length == this.selectedEmployeeId.length) {
        this.isAllEmployeeSelected = true;
      }
    })
  }
  debounceTimer: any;
  selectedEmployeeId: any = [];
  isAllEmployeeSelected: boolean = false;
  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    } if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.getEmpListForEssSetup();
    }, 300);
  }
  onClickSaveViewEmp() {

    let data = {}
    if (this.moduleName == 'ESS') {
      this.selectedEmployeeId = this.selectedEmployeeId.map((item: any) => {
        if (typeof item === 'object' && item.id) {
          // Find in firstArray and merge if necessary
          const foundItem = this.listOfEmployees.find((emp: any) => emp.id === item.id);
          return foundItem ? { ...foundItem, ...item } : item;
        }
        return this.listOfEmployees.find((emp: any) => emp.id === item) || null; // Get full object if only id is provided
      }).filter(Boolean); // Remove null values if no match is foun

      data = {
        selectedEmployeeId: this.selectedEmployeeId,
      }
    } else {
      this.selectedEmployeeId = this.selectedEmployeeId.map((item: any) => {
        if (typeof item === 'object' && item.id) {
          // Find in firstArray and merge if necessary
          const foundItem = this.listOfEmployees.find((emp: any) => emp.id === item.id);
          return foundItem ? { ...foundItem, ...item } : item;
        }
        return this.listOfEmployees.find((emp: any) => emp.id === item) || null; // Get full object if only id is provided
      }).filter(Boolean); // Remove null values if no match is foun

      data = {
        selectedEmployeeId: this.selectedEmployeeId,
      }
    }
    this.dialogRef.close(data);
  }
  onSelectAllEmployee(event: any) {
    this.selectedEmployeeId = [];
    if (event.checked) {
      this.isAllEmployeeSelected = true;
      this.listOfEmployees.forEach((ele: any) => {
        ele.isChecked = true
        this.selectedEmployeeId.push(ele);
      });
    } else {
      this.listOfEmployees.forEach((ele: any) => {
        ele.isChecked = false
      });
      this.isAllEmployeeSelected = false;
      this.selectedEmployeeId = [];
    }
  }
  onSelectSingleEmployee(event: any, item: any, index: any) {
    if (event.checked) {
      this.listOfEmployees[index].isChecked = true;
      this.selectedEmployeeId.push(item);
    } else {
      this.isAllEmployeeSelected = false;
      this.listOfEmployees[index].isChecked = false;
      this.listOfEmployees.forEach((ele: any, ind: any) => {
        if (ele.isChecked == false) {
          this.selectedEmployeeId.splice(ind, 1);
        }
      });
    }
  }
  selectedSurveyName: any = null;
  selectedSurveyStartDate: any;
  selectedSurveyEndDate: any;
  selectedSurveyStatus: any;
  isShowDashboardToHR: any;
  onSeletReminderOption: boolean = false;
  isShowReminderDate: any = false;
  selectedTemplateColorName: any;
  templateColorList = [
    {
      stripcolor: "#db4437",
      backgroundColor: "#fae3e1",
      colorName: "Red"
    },
    {
      stripcolor: "#673ab7",
      backgroundColor: "#f0ebf8",
      colorName: "Purple"
    },
    {
      stripcolor: "#3f51b5",
      backgroundColor: "#eceef8",
      colorName: "Indigo"
    }, {
      stripcolor: "#4285f4",
      backgroundColor: "#e3edfd",
      colorName: "Blue"
    },
    {
      stripcolor: "#03a9f4",
      backgroundColor: "#d9f2fd",
      colorName: "Light Blue"
    },
    {
      stripcolor: "#00bcd4",
      backgroundColor: "#d9f5f9",
      colorName: "Cyan"
    },
    {
      stripcolor: "#ff5722",
      backgroundColor: "#ffe6de",
      colorName: "Red Orange"
    },

    {
      stripcolor: "#ff9800",
      backgroundColor: "#fff0d9",
      colorName: "Orange"
    },
    {
      stripcolor: "#009688",
      backgroundColor: "#d9efed",
      colorName: "Teal"
    },
    {
      stripcolor: "#4caf50",
      backgroundColor: "#e4f3e5",
      colorName: "Green"
    },
    {
      stripcolor: "#607d8b",
      backgroundColor: "#e7ecee",
      colorName: "Blue Gray"
    },
    {
      stripcolor: "#9e9e9e",
      backgroundColor: "#f0f0f0",
      colorName: "Gray"
    },
  ]
  selectedTemplateColorCode: any = '#F6921E';
  selectedtemplateBgColor: any;
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  ratingList = [
    {
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: null
    },
  ];



  dimensionsTemplateList = [
    {
      dimensionName: null,
      questions: [
        {
          id: null,
          question: null,
          questionNumber: null,
          questionType: null
        },
      ],
    },
  ];
  mySurveyQuestionList: any = [];
  ratingListOnRatingBased: any = [];
  infoListData: any[] = [];
  getessByID() {
  
    
    this.httpService.callGetService(this.config.getessByID + this.selectedSurveyID).subscribe((data: any) => {
      console.log(this.selectedSurveyID);
      this.selectedSurveyName = data?.data?.essName;
      this.selectedSurveyStartDate = data?.data?.startDate;
      this.selectedSurveyEndDate = data?.data?.endDate;
      this.selectedSurveyStatus = data?.data?.essStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      this.selectedEmployeeId = data?.data?.employee
      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.surveyDateOfJoining = data?.data?.surveyCutoff;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.selectedTemplateColorName = data?.data?.templateName;

      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;        
      }
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: null
          },
        ]
      }
      this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
      this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
      if (data?.data?.questions?.length != 0) {
        this.dimensionsTemplateList = data?.data?.questions;
      } else {
        this.dimensionsTemplateList = [
          {
            dimensionName: null,
            questions: [
              {
                id: null,
                question: null,
                questionNumber: null,
                questionType: null
              },
            ],
          },
        ];
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;

      this.mySurveyQuestionList = data?.data?.questions.flatMap((dimension: { questions: any; }) => dimension.questions);
      this.mySurveyQuestionList = this.mySurveyQuestionList.map((question: any) => ({
        ...question,
        answer: null // You can set a default value or any specific value
      }));
      this.ratingListOnRatingBased = [];
      data?.data?.ratings.forEach((ele: any) => {
        if (ele.questionType == 'Rating Based') {
          this.ratingListOnRatingBased.push(ele)
        }
      })
    })
  }
  exportEssEmployee() {

    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "endDate": this.selectedEssendDate,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": this.datePipe.transform(this.surveyDateOfJoining, "yyyy-MM-dd"),
      "search": this.searchString,
       "id": this.selectedEmployeeId?.map((ele: { id: any; }) => ele.id),
    }
    // this.loader.simpleLoader();
    this.httpService.callPostService(this.config.downloadEssEmps, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, "Employees.xlsx");
    })
  }
  essNamesList: any = [];
  allEssDateList: any = [];
  getessName() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      this.httpService.callGetService(this.config.getessName + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {

        this.essNamesList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.essName,
          }
          this.essNamesList.push(obj);
        });
      
        this.allEssDateList = data?.data?.flatMap((item: any) => this.getDatesBetween(item.startDate, item.endDate));

        this.allEssDateList = Array.from(new Set(this.allEssDateList));
      })
    }
  }
  getDatesBetween(startDateStr: string, endDateStr: string): string[] {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const dates: string[] = [];

    while (startDate <= endDate) {
      dates?.push(startDate.toISOString()?.split("T")[0]); // Format as YYYY-MM-DD
      startDate?.setDate(startDate.getDate() + 1); // Increment date by 1
    }

    return dates;
  }

  today: Date = new Date(new Date().setHours(0,0,0,0));

// datestartFilter = (d: Date | null): boolean => {
//   if (!d) return false;
//   const date = new Date(d);
//   return date.setHours(0,0,0,0) === this.today.getTime();
// };


  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    // Ensure d is a Date object
    const date = new Date(d);

    // Normalize date to ignore time part
    const selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const minDateOnly = new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate());

    // Convert to YYYY-MM-DD string for accurate comparison
    const dateString = selectedDate.toISOString().split('T')[0];

    console.log('Checking date:', dateString, 'Min Date:', minDateOnly.toISOString().split('T')[0]);

    // Ensure the selected date is not before minDate and not in the disabled list
    return selectedDate >= minDateOnly && !this.allEssDateList.includes(dateString);
  };
  selectedReviewName:any;
  selectedReviewStartDate:any;
  selectedReviewStatus:any;
  selectedReviewEndDate:any;
  isExternalCustomerEnabled:any;
  stakeHoldersArrayForSetup:any=[];
  reviewDateOfJoining:any;
  ratingBasedList:any=[];
  externalCustomerWeightage:any;
  subordinateWeightage:any;
  superiorWeightage:any;
  selfWeightage:any;
  peerWeightage:any;
  stakeholdersArray:any=[];
  internalCustomerWeightage:any;
  getCompetencyList:any=[];
  participatein360ReviewArrayList:any=[];
  getReviewByID() {
    const request = {
      "id": this.selectedSurveyID,
      "search": null
    }
    this.httpService.callPostService(this.config.getReview360ById, request).subscribe((data: any) => {
      this.selectedReviewName = data?.data?.reviewName;
      this.selectedReviewStartDate = data?.data?.startDate;
      this.selectedReviewEndDate = data?.data?.endDate;
      this.selectedReviewStatus = data?.data?.reviewStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr;
      this.isExternalCustomerEnabled = data?.data?.isExternalCustomerEnabled;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      if (this.isExternalCustomerEnabled == true) {
        this.stakeHoldersArrayForSetup.push({ name: 'External Customer' });
      }

      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.selectedEmployeeId = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        }
        this.selectedEmployeeId.push(obj);
      })
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';
      this.reviewDateOfJoining = data?.data?.reviewCutoff;
      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
        localStorage.setItem('intructionList', JSON.stringify(this.intructionList));        
      }else{
        localStorage.removeItem('intructionList')
      }
      this.ratingBasedList = [];
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
        data?.data?.ratings?.forEach((ele: any) => {
          if (ele.questionType == 'Rating Based') {
            let obj = {
              id: ele.id,
              questionType: ele.questionType,
              rating: ele.rating,
              ratingDefinition: ele.ratingDefinition
            }
            this.ratingBasedList.push(obj)
          }
        })
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: null
          },
        ]
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;
      this.externalCustomerWeightage = data?.data?.externalCustomerWeightage
      this.subordinateWeightage = data?.data?.subordinateWeightage
      this.superiorWeightage = data?.data?.superiorWeightage
      this.selfWeightage = data?.data?.selfWeightage
      this.peerWeightage = data?.data?.peerWeightage
      this.internalCustomerWeightage = data?.data?.internalCustomerWeightage
      
      this.stakeholdersArray = data?.data?.stakeholders;
      this.getCompetencyList = data?.data?.competencies;

      this.participatein360ReviewArrayList = data?.data?.competencies?.flatMap((item: any) => item.competencies)
        .reduce((acc: any, curr: any) => {
          const existing = acc.find((comp: any) => comp.competencyName === curr.competencyName);
          if (existing) {
            existing.questions.push(...curr.questions);
          } else {
            acc.push({ competencyName: curr.competencyName, questions: [...curr.questions] });
          }
          return acc;
        }, [] as { competencyName: string; questions: { id: number; question: string; questionType: string, answers: any }[] }[]);
    })
  }




  
  onClickDownloadGraphAsPdf(elementId:any){
    // let title = '';
    // if(id == 'activeessReview'){
    //   title = 'Employee Satisfaction Survey'
    // }else if(id == 'active360Review'){
    //   title = '360 Review'
    // }
    // this.pdfDownload.PDFDownload(
    //   id, // chartId
    //   title, // lable
    // );
    

    const element = document.getElementById(elementId);

    if (!element) {
      console.warn('Element not found:', elementId);
      return;
    }
    element.classList.add('getAnnouncementPdf');
    setTimeout(() => {
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
        backgroundColor: null,
        windowWidth: document.body.scrollWidth,
        scrollY: -window.scrollY,
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
  
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
        let heightLeft = imgHeight;
        let position = 0;
  
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
  
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pdfHeight;
        }

        pdf.save('Employee Satisfaction Survey.pdf');
        element.classList.remove('getAnnouncementPdf');
      });
    }, 200); 
  }
}
